"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/fanclub/v1/internal_service.proto (package spwn.fanclub.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalFanclubService = void 0;
const internal_service_pb_1 = require("./internal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.fanclub.v1.InternalFanclubService
 */
exports.InternalFanclubService = {
    typeName: "spwn.fanclub.v1.InternalFanclubService",
    methods: {
        /**
         * @generated from rpc spwn.fanclub.v1.InternalFanclubService.GetPlansByBrandId
         */
        getPlansByBrandId: {
            name: "GetPlansByBrandId",
            I: internal_service_pb_1.InternalFanclubServiceGetPlansByBrandIdRequest,
            O: internal_service_pb_1.InternalFanclubServiceGetPlansByBrandIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=internal_service_connect.js.map